module.exports = __webpack_public_path__ + "img/Loyalty Icon - charcoal.c946fd88.svg";